import React from 'react';

import { TextInput } from 'components/ucl';
import { t } from 'state/intl/translations';

interface IFavoriteInput {
  errorMessage?: string;
  favoriteName?: string;
  onChange: (value: string) => void;
  testID?: string;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

export const FavoriteInput: React.FC<IFavoriteInput> = ({
  errorMessage = '',
  favoriteName,
  onChange,
  testID,
  setErrorMessage,
}) => {
  const setInputErrorMessage = (favoriteName: string) => {
    setErrorMessage(!favoriteName ? t('saveFavoriteOrderNameError') : '');
  };

  const favoriteNameValue = favoriteName ?? '';

  return (
    <TextInput
      testID={testID}
      required
      label={t('orderName')}
      value={favoriteNameValue}
      onChangeText={value => {
        setInputErrorMessage(value.trim());
        return onChange(value);
      }}
      onBlur={() => {
        setInputErrorMessage(favoriteNameValue);
      }}
      returnKeyType="done"
      errorMessage={errorMessage}
      aria-label={errorMessage ? errorMessage : t('orderName')}
    />
  );
};
